import React from 'react';

export const PortalNotifications = ({ notifications, unreadCount, show, setShow, markRead }) => (
  <div style={{ position: 'relative' }}>
    <button data-testid="notification-bell" onClick={() => setShow(!show)} style={{
      background: '#fff', border: '1px solid #ECE7DE', borderRadius: 10, padding: '0.5rem 0.75rem',
      cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.375rem', fontSize: '0.8125rem', color: '#002A38'
    }}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>
      </svg>
      Notifications
      {unreadCount > 0 && (
        <span style={{ background: '#DC2626', color: '#fff', borderRadius: 999, padding: '0.125rem 0.375rem', fontSize: '0.625rem', fontWeight: 700 }}>{unreadCount}</span>
      )}
    </button>

    {show && (
      <div data-testid="notification-dropdown" style={{
        position: 'absolute', right: 0, top: '100%', marginTop: 8, width: 380, maxHeight: 400,
        background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
        overflow: 'auto', zIndex: 100,
      }}>
        <div style={{ padding: '0.875rem 1rem', borderBottom: '1px solid #ECE7DE', fontWeight: 600, fontSize: '0.875rem', color: '#002A38' }}>
          Notifications ({notifications.length})
        </div>
        {notifications.length === 0 ? (
          <div style={{ padding: '2rem', textAlign: 'center', color: '#94A3B8', fontSize: '0.8125rem' }}>No notifications yet</div>
        ) : (
          notifications.map(n => (
            <div key={n._id} onClick={() => markRead(n._id)} style={{
              padding: '0.875rem 1rem', borderBottom: '1px solid #F1F5F9', cursor: 'pointer',
              background: n.read ? '#fff' : 'rgba(30,104,255,0.03)',
            }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '0.5rem' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: '0.8125rem', fontWeight: 600, color: '#002A38', marginBottom: '0.25rem' }}>
                    {!n.read && <span style={{ display: 'inline-block', width: 6, height: 6, borderRadius: '50%', background: '#0076A3', marginRight: 6 }} />}
                    {n.title}
                  </div>
                  <div style={{ fontSize: '0.75rem', color: '#64748B', lineHeight: 1.5 }}>{n.message}</div>
                  {n.data?.access_code && (
                    <a href={`/take-assessment/${n.data.access_code}`} target="_blank" rel="noopener noreferrer"
                      style={{ display: 'inline-block', marginTop: '0.375rem', fontSize: '0.6875rem', fontWeight: 600, color: '#0076A3', textDecoration: 'none' }}
                      onClick={e => e.stopPropagation()}>
                      Take Assessment &rarr;
                    </a>
                  )}
                </div>
                <span style={{ fontSize: '0.625rem', color: '#94A3B8', whiteSpace: 'nowrap' }}>
                  {new Date(n.created_at).toLocaleDateString()}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    )}
  </div>
);
